<template>
  <v-flex
    xs12
    sm4
    offset-sm1
  >
      <dymoPrintPreview
      v-on:Modalclose="Printdialog = false"
      v-if="Printdialog && !annoy"
      :assets="[assetDetail]"
    />
    <MagentoDetail
      v-on:mageModalclose="magentoDialog = false"
      :assetList='[assetDetail]'
      v-if="magentoDialog && !annoy"
    />
    <EditDetailsMonitor
      v-on:computerDetailModalClose="computerDetailDialog = false"
      v-if='computerDetailDialog && !annoy'
      :assetDetail='assetDetail'
    />

    <v-card class='mt-5'>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-toolbar-title>{{assetDetail.Discovery.AssetTag}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-avatar
          v-if='!annoy'
          @click='magentoDialog = true'
          :tile="true"
          :size="25"
        >
          <img
            style='cursor : pointer ; width : 100% ;margin-right : 50%'
            title='push item to magento'
            src="https://firebasestorage.googleapis.com/v0/b/tech-reuse.appspot.com/o/112651_development_435x512.png?alt=media&token=842aeaf9-f41d-4b86-a0d3-471952d2d437"
          >
        </v-avatar>
          <v-btn
          icon
          v-if='!annoy'
          @click="Printdialog= true"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          v-if='!annoy'
          icon
          @click="computerDetailDialog = true"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn
          v-if='!annoy'
          icon
          @click="save"
        >
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <br/>
       <span class='font-weight-bold'>{{assetDetail.Discovery.monitorID}} Monitor {{assetDetail.Discovery.Model}} {{assetDetail.Discovery.Size}}"</span>
        <v-text-field
          class='pl-3 pr-3'
          :disabled='disabled'
          v-model='assetDetail.mischardwarespec.conditionDesc'
          label="Condition Description"
        ></v-text-field>
      <v-list two-line>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/organization-filled.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.monitorID}}</v-list-tile-title>
            <v-list-tile-sub-title>Brand</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/material/48/000000/laptop.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.Model}}</v-list-tile-title>
            <v-list-tile-sub-title>Model</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/bag-brand.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.Serial}}</v-list-tile-title>
            <v-list-tile-sub-title>Serial</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/aspect-ratio.png">
            </v-avatar>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.Size}}</v-list-tile-title>
            <v-list-tile-sub-title>Screen Size</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
               <v-divider inset></v-divider>
                <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
                <img src="https://img.icons8.com/ios/50/000000/screen-resolution.png">
            </v-avatar>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.sizeHorCM}}</v-list-tile-title>
            <v-list-tile-sub-title>Horizontal Size (cm)</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
                <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/aspect-ratio.png">
            </v-avatar>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.sizeVerCM}}</v-list-tile-title>
            <v-list-tile-sub-title>Vertical Size (cm)</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
     

        <v-divider inset></v-divider>

        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/barcode-scanner-filled.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{assetDetail.Discovery.pnpID}}</v-list-tile-title>
            <v-list-tile-sub-title>PNP Id</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-avatar
              :tile="true"
              :size="30"
            >
              <img src="https://img.icons8.com/metro/52/000000/pallet.png">
            </v-avatar>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title
              v-if='assetDetail.Discovery.location'
              style='cursor : pointer;color:blue'
              @click='goTo'
            >{{assetDetail.Discovery.location}}</v-list-tile-title>
            <v-list-tile-sub-title>Location</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
 <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.displayType'
        label="Display Type"
      ></v-text-field>
       <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.videoInput'
        label="Video Type"
      ></v-text-field>
         <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.color'
        label="Color"
      ></v-text-field>
            <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.manufeactureDate'
        label="Manufeacture Date"
      ></v-text-field>
          <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.grade'
        label="Grade"
      ></v-text-field>
    <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.aspectRatio'
        label="Aspect Ratio"
      ></v-text-field>
      <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.brightness'
        label="Brightness"
      ></v-text-field>
            <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.contrastRatio'
        label="Contrast Ratio"
      ></v-text-field>
            <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.maxResuo'
        label="Max Resolution"
      ></v-text-field>
        <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.refreshRate'
        label="Refresh Rate"
      ></v-text-field>
        <v-text-field
        :disabled='disabled'
        class='pl-3 pr-3'
        v-model='assetDetail.mischardwarespec.responseTime'
        label="Response Time"
      ></v-text-field>

    </v-card>
  </v-flex>
</template>


<script>
const fb = require('../firebaseConfig.js')
import dymoPrintPreview from '../components/PrintPreview.vue'
import MagentoDetail from '../components/MagentoDialog.vue'
import EditDetailsMonitor from '../components/EditDetailsMonitor'
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    dymoPrintPreview,
    MagentoDetail,
    EditDetailsMonitor
  },
  props: {
    assetDetail: Object,
    annoy: Boolean
  },
    mounted () {
    if (this.annoy) {
      this.disabled = true
    }
  },
  data () {
    return {
      Printdialog : false,
      disabled : false,
      Printdialog: false,
      magentoDialog: false,
      computerDetailDialog: false,
      
    }
  },
    computed: {
    ...mapFields([
      "snackBarMessage",
      "snackBar",
      "snackBarcolor"
    ])  },
  methods: {
        save () {
      fb.AssetsCollections.where("Discovery.AssetTag", "==", this.$route.params.id).get().then(d => {
        d.forEach((doc) => {
          var docID = doc.id
          fb.AssetsCollections.doc(docID).set(this.assetDetail).then(() => {
            this.snackBar = true
            this.snackBarMessage = "update completed"
            this.snackBarcolor = "success"
          })

        })
      })
    }
  }
}
</script>
